import { FormHelpersService } from "./FormHelpersService";

const GfcValidationSummaryDirective = function (FormHelpers: FormHelpersService) {
    function expandPredicate(predicate, fieldName): string {
        return predicate.replace(/([^\.]|^)(\$[\w]+)/g, "$1" + fieldName + ".$2");
    }

    function findControlToValidate(element, field) {
        var input = element.closest("form, ng-form").find("[name=" + field + "]");

        if (input.length > 0 && input[0].localName == "select") {
            input = input.siblings("div.select-wrapper input.select-dropdown");
        }

        return input;
    }

    function checkFormValue(scope, element, field) {
        if (!field) return;

        var input = findControlToValidate(element, scope.field);

        if (field.$invalid) {
            if (field.$dirty) {
                input.removeClass("valid");
                input.addClass("invalid");
            } else {
                input.removeClass("invalid");
            }
        } else {
            if (!field.$pristine)
                input.addClass("valid");
            else
                input.removeClass("valid");

            input.removeClass("invalid");
        }
    }

    function findForm(scope, formName: string) {
        if (!scope) {
            throw "Could not find form '" + formName + "'";
        }

        const ctrlFormController = FormHelpers.getCtrlFormController(scope, formName);
        if (ctrlFormController) {
            return ctrlFormController;
        }
    
        if (scope.hasOwnProperty(formName)) {
            return scope[formName];
        }

        return findForm(scope.$parent, formName);
    }

    return {
        scope: {
            form: '@',
            field: '@',
            messages: '=',
            noHook: '@?',
            async: '@?'
        },
        restrict: 'E',
        template: function (element, attrs) {
            if (!attrs.messages) return '';

            return '<div class="errorText" ng-repeat-start="prop in properties" ng-show="{{ prop.predicate }}">{{ prop.message }}</div><div ng-repeat-end class="clearfix"></div>'
        },
        link: function (scope, element, attrs, ctrl) {
            if (!scope.noHook) {
                var fieldName = "_." + scope.field;

                scope.properties = [];

                scope._ = findForm(scope.$parent, scope.form);

                var messages = scope.messages;

                if (messages) {
                    for (var index in messages) {
                        var message = messages[index];

                        if (message) {
                            var predicate = "$dirty && (" + index + ")";

                            var predicate = expandPredicate(predicate, fieldName);

                            scope.properties.push({ predicate: predicate, message: message });
                        }
                    }
                }

                var unregister = scope.$watchCollection(fieldName, function (field) {
                    checkFormValue(scope, element, field);
                });

                scope.$on("$destroy", function () {
                    unregister();
                });
            }
        }
    }
};

GfcValidationSummaryDirective.$inject = ["FormHelpers"];

export { GfcValidationSummaryDirective };